var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconShareKakako = function SvgIconShareKakako(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_share_kakako_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E7E8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8.75c-3.382 0-6.125 2.177-6.125 4.865 0 1.726 1.136 3.242 2.842 4.107l-.577 2.166a.18.18 0 0 0 .169.237.175.175 0 0 0 .106-.04l2.482-1.686c.36.051.728.08 1.103.08 3.382 0 6.125-2.177 6.125-4.864 0-2.688-2.743-4.865-6.125-4.865Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_share_kakako_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgIconShareKakako;